<script>
  import Hero from "$lib/components/Hero/Hero.svelte";
  import PageBody from "$lib/components/Page/PageBody.svelte";
  import Markdown from "$lib/components/Markdown.svelte";
  import ItemPreviewList from "$lib/contentTypes/ItemPreviewList.svelte";
  import { formatDate } from "$lib/utilities/date";

  export let page;

  let closingText = page.fields.closingTextMarkdown;
  const byline = {
    publishDate: formatDate(page.fields.pageData.fields.legacyPublishDate || page.sys.updatedAt, {
      hour: undefined,
      minute: undefined,
      timeZoneName: undefined
    })
  };

  // TODO: figure out what authors looks like if anyone uses it
  // if(page.fields.authors) {
  // }
</script>

<div class="w-full px-24 md:px-175 lg:max-w-1014 lg:px-0 m-auto">
  <Hero
    title={page.fields.pageData.fields.headline}
    featuredImage={page.fields.featuredImageComponent}
    {byline}
    parentInfo={page.fields.pageData.fields.parentInfo}
  />

  <div class="w-full justify-center page-level-padding internal-page-spacing">
    <article
      data-headings-increment
      class={page.fields.trailingStoryLists ? "" : "last-page-element"}
    >
      <PageBody body={page.fields.body} />
      {#if closingText}<Markdown input={closingText} class="pt-48 lg:pt-72" />
      {/if}
    </article>

    {#if page.fields.trailingStoryLists}
      {#each page.fields.trailingStoryLists as listData}
        <div class="last-page-element">
          <!-- div added so that the gap doesn't double add spacing under the section header. -->
          <ItemPreviewList data={listData} />
        </div>
      {/each}
    {/if}
  </div>
</div>
